import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'templateVariableFormat'
})
export class TemplateVariableFormatPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    return value?.replace(/\$/g,'')
  }

}
